import { useState } from "react";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";

const RESOURCE_LABELS = {
    financial: "Financeiro",
    customers: "Clientes",
    storage: "Estoque",
    menu: "Cardápio",
    sales: "Vendas",
    orders: "Pedidos",
    wallet: "Carteira Digital",
    reservations: "Reservas"
};

const ACTION_LABELS = {
    create: "Criar",
    view: "Visualizar",
    update: "Editar",
    update_credits: "Recarregar Crédito Foodz",
    add_expense: "Lançar Correções de Crédito Foodz",
    delete: "Excluir",
    open_registry: "Abrir Caixa",
    close_registry: "Fechar Caixa",
    registry_outgoing: "Saídas de Caixa",
    send_notifications: "Enviar Notificações",
    set_received_payment: "Acusar Recebimentos",
    concilate_payments: "Conciliar Pagamentos Recebidos",
    change_status: "Gerenciar Pedidos",
    cancel_order: "Cancelar Pedidos",
    reprint_receipts: "Reimprimir Recibos",
    transfer: "Realizar Transferências",
    manage: "Gerenciar",
    anticipate: "Solicitar Antecipações",
    adjust: "Ajustar Estoque"
};

const DualListBox = ({ leftItems, rightItems, onAdd, onRemove, onSave }) => {
    const [selectedLeft, setSelectedLeft] = useState([]);
    const [selectedRight, setSelectedRight] = useState([]);

    const makeKey = (item) => `${item.resource}-${item.action}`;

    const groupByResource = (items) =>
        items.reduce((acc, item) => {
            if (!acc[item.resource]) acc[item.resource] = [];
            acc[item.resource].push(item);
            return acc;
        }, {});

    const leftGrouped = groupByResource(leftItems);
    const rightGrouped = groupByResource(rightItems);

    const toggleSelection = (key, selected, setSelected) => {
        setSelected((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        );
    };

    const renderList = (groupedItems, selectedKeys, setSelected) => (
        <div className="overflow-y-auto max-h-80">
            {Object.entries(groupedItems).map(([resource, items]) => (
                <div key={resource} className="mb-4">
                    <p className="font-semibold text-gray-600 mb-1">
                        {RESOURCE_LABELS[resource] || resource}
                    </p>
                    <ul className="space-y-1">
                        {items.map((item) => {
                            const key = makeKey(item);
                            const isSelected = selectedKeys.includes(key);
                            return (
                                <li
                                    key={key}
                                    className={`px-3 py-1 rounded cursor-pointer ${isSelected ? "bg-gray-200" : "hover:bg-gray-100"
                                        }`}
                                    onClick={() => toggleSelection(key, selectedKeys, setSelected)}
                                >
                                    {ACTION_LABELS[item.action] || item.action}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );

    return (
        <div className="">
            <div className="flex gap-4 md:gap-6">
                <div className="flex-1 mx-6">
                    <h4 className="text-lg font-semibold mb-2">Disponíveis</h4>
                    <div className="border rounded-xl p-2 bg-white shadow-inner">
                        {renderList(leftGrouped, selectedLeft, setSelectedLeft)}
                    </div>
                </div>

                <div className="flex flex-col justify-center gap-2">
                    <button
                        onClick={() => {
                            const perms = leftItems.filter((p) =>
                                selectedLeft.includes(makeKey(p))
                            );
                            if (perms.length) {
                                perms.forEach((perm) => onAdd(perm));
                                setSelectedLeft([]);
                            }
                        }}
                        disabled={!selectedLeft.length}
                        className="px-4 py-2 bg-custom_blue text-white rounded-xl hover:bg-blue-600 disabled:bg-gray-300"
                    >
                        <MdKeyboardArrowRight />
                    </button>

                    <button
                        onClick={() => {
                            const perms = rightItems.filter((p) =>
                                selectedRight.includes(makeKey(p))
                            );
                            if (perms.length) {
                                perms.forEach((perm) => onRemove(perm));
                                setSelectedRight([]);
                            }
                        }}
                        disabled={!selectedRight.length}
                        className="px-4 py-2 bg-custom_red text-white rounded-xl hover:bg-red-600 disabled:bg-gray-300"
                    >
                        <MdKeyboardArrowLeft />
                    </button>
                </div>

                <div className="flex-1 flex flex-col mx-6">
                    <h4 className="text-lg font-semibold mb-2">Permissões do usuário</h4>
                    <div className="border rounded-xl p-2 bg-white shadow-inner flex-1">
                        {renderList(rightGrouped, selectedRight, setSelectedRight)}
                    </div>
                </div>
            </div>

            <div className="flex justify-center mt-4">
                <button
                    onClick={onSave}
                    className="px-6 py-2 w-1/5 bg-custom_green text-white font-semibold rounded-xl hover:bg-green-600 transition"
                >
                    Salvar
                </button>
            </div>
        </div>
    );
};

export default DualListBox;
